
import { MOCK_BALANCES, MOCK_BANK_ACCOUNTS, MOCK_DATES } from './shared.mock';

export const paymentPageDataMock = {
  default: {
    nextDueDate: MOCK_DATES.paymentDueDate().toISOString(),
    paymentsMadeThisMonth: false,
    unpaidPrincipal: MOCK_BALANCES.mortgage.unpaidPrincipal,
    principalPaid: MOCK_BALANCES.mortgage.beginningPrincipal - MOCK_BALANCES.mortgage.unpaidPrincipal,
    escrowBalance: MOCK_BALANCES.mortgage.escrowBalance,
    paymentsDue: [
      {
        dueDate: MOCK_DATES.paymentDueDate().toISOString(),
        totalMonthlyPayment: MOCK_BALANCES.mortgage.paymentDue,
        principalAndInterest: MOCK_BALANCES.mortgage.principalAndInterest,
        taxAndInsurance: MOCK_BALANCES.mortgage.taxAndInsurance,
      },
    ],
    fees: [],
    profiles: [
      {
        profileId: MOCK_BANK_ACCOUNTS.chase.profileId,
        lastFourAccountNumber: MOCK_BANK_ACCOUNTS.chase.lastFourAccountNumber,
        accountType: MOCK_BANK_ACCOUNTS.chase.accountType,
        accountProfile: MOCK_BANK_ACCOUNTS.chase.accountProfile,
        bankName: MOCK_BANK_ACCOUNTS.chase.bankName,
        defaultPaymentProfile: true,
        firstName: 'John',
        lastName: 'Smith',
      },
      {
        profileId: MOCK_BANK_ACCOUNTS.bankOfAmerica.profileId,
        lastFourAccountNumber: MOCK_BANK_ACCOUNTS.bankOfAmerica.lastFourAccountNumber,
        accountType: MOCK_BANK_ACCOUNTS.bankOfAmerica.accountType,
        accountProfile: MOCK_BANK_ACCOUNTS.bankOfAmerica.accountProfile,
        bankName: MOCK_BANK_ACCOUNTS.bankOfAmerica.bankName,
        defaultPaymentProfile: false,
        firstName: 'John',
        lastName: 'Smith',
      },
    ],
    minPayOnDate: MOCK_DATES.minPaymentDate().toISOString(),
    maxPayOnDate: MOCK_DATES.maxPaymentDate().toISOString(),
    isEligible: true,
    eligibilityErrors: [],
    get pending() {
      return paymentHistoryMock['with-history'].pending;
    },
    get posted() {
      return paymentHistoryMock['with-history'].posted;
    },
  },

  'with-fees': {
    nextDueDate: MOCK_DATES.paymentDueDate().toISOString(),
    paymentsMadeThisMonth: false,
    unpaidPrincipal: MOCK_BALANCES.mortgage.unpaidPrincipal,
    principalPaid: MOCK_BALANCES.mortgage.beginningPrincipal - MOCK_BALANCES.mortgage.unpaidPrincipal,
    escrowBalance: MOCK_BALANCES.mortgage.escrowBalance,
    paymentsDue: [
      {
        dueDate: MOCK_DATES.paymentDueDate().toISOString(),
        totalMonthlyPayment: MOCK_BALANCES.mortgage.paymentDue,
        principalAndInterest: MOCK_BALANCES.mortgage.principalAndInterest,
        taxAndInsurance: MOCK_BALANCES.mortgage.taxAndInsurance,
      },
    ],
    fees: [
      { type: 'LateFee', amount: 75.0, description: 'Late Payment Fee' },
      { type: 'NSFFee', amount: 25.0, description: 'Returned Payment Fee' },
      {
        type: 'OtherFees',
        amount: 150.0,
        description: 'Other Fees',
        breakdown: [
          { type: 5, code: '4', description: 'Recording Fee', amount: 100.0 },
          { type: 12, code: 'E', description: 'Convenience Fee', amount: 50.0 },
        ],
      },
    ],
    profiles: [
      {
        profileId: MOCK_BANK_ACCOUNTS.chase.profileId,
        lastFourAccountNumber: MOCK_BANK_ACCOUNTS.chase.lastFourAccountNumber,
        accountType: MOCK_BANK_ACCOUNTS.chase.accountType,
        accountProfile: MOCK_BANK_ACCOUNTS.chase.accountProfile,
        bankName: MOCK_BANK_ACCOUNTS.chase.bankName,
        defaultPaymentProfile: true,
        firstName: 'John',
        lastName: 'Smith',
      },
    ],
    minPayOnDate: MOCK_DATES.minPaymentDate().toISOString(),
    maxPayOnDate: MOCK_DATES.maxPaymentDate().toISOString(),
    isEligible: true,
    eligibilityErrors: [],
    get pending() {
      return paymentHistoryMock['with-history'].pending;
    },
    get posted() {
      return paymentHistoryMock['with-history'].posted;
    },
  },

  delinquent: {
    nextDueDate: MOCK_DATES.pastDueDate().toISOString(),
    paymentsMadeThisMonth: false,
    unpaidPrincipal: MOCK_BALANCES.mortgage.unpaidPrincipal,
    principalPaid: MOCK_BALANCES.mortgage.beginningPrincipal - MOCK_BALANCES.mortgage.unpaidPrincipal,
    escrowBalance: MOCK_BALANCES.mortgage.escrowBalance,
    paymentsDue: [
      {
        dueDate: new Date(2026, 0, 1).toISOString(),
        totalMonthlyPayment: MOCK_BALANCES.mortgage.paymentDue,
        principalAndInterest: MOCK_BALANCES.mortgage.principalAndInterest,
        taxAndInsurance: MOCK_BALANCES.mortgage.taxAndInsurance,
      },
      {
        dueDate: new Date(2026, 1, 1).toISOString(),
        totalMonthlyPayment: MOCK_BALANCES.mortgage.paymentDue,
        principalAndInterest: MOCK_BALANCES.mortgage.principalAndInterest,
        taxAndInsurance: MOCK_BALANCES.mortgage.taxAndInsurance,
      },
    ],
    fees: [{ type: 'LateFee', amount: 125.0, description: 'Late Payment Fee' }],
    profiles: [
      {
        profileId: MOCK_BANK_ACCOUNTS.chase.profileId,
        lastFourAccountNumber: MOCK_BANK_ACCOUNTS.chase.lastFourAccountNumber,
        accountType: MOCK_BANK_ACCOUNTS.chase.accountType,
        accountProfile: MOCK_BANK_ACCOUNTS.chase.accountProfile,
        bankName: MOCK_BANK_ACCOUNTS.chase.bankName,
        defaultPaymentProfile: true,
        firstName: 'John',
        lastName: 'Smith',
      },
    ],
    minPayOnDate: MOCK_DATES.minPaymentDate().toISOString(),
    maxPayOnDate: MOCK_DATES.maxPaymentDate().toISOString(),
    isEligible: true,
    eligibilityErrors: [],
  },

  'not-eligible': {
    nextDueDate: MOCK_DATES.paymentDueDate().toISOString(),
    paymentsMadeThisMonth: false,
    unpaidPrincipal: MOCK_BALANCES.mortgage.unpaidPrincipal,
    principalPaid: 0,
    escrowBalance: MOCK_BALANCES.mortgage.escrowBalance,
    paymentsDue: [],
    fees: [],
    profiles: [],
    minPayOnDate: MOCK_DATES.minPaymentDate().toISOString(),
    maxPayOnDate: MOCK_DATES.maxPaymentDate().toISOString(),
    isEligible: false,
    eligibilityErrors: ['Online payments are not available for this loan. Please contact customer service.'],
  },
};

function buildPendingOtp(
  id: string,
  daysFromNow: number,
  amount: number,
  opts: {
    confirmationNumber?: string;
    profileId?: string;
    channelId?: number;
    additionalPrincipal?: number;
    additionalEscrow?: number;
  } = {},
) {
  return {
    paymentId: id,
    loanNumber: 1234567890,
    confirmationNumber: opts.confirmationNumber ?? `CONF-OTP-${id}`,
    createdAt: MOCK_DATES.paymentDate(1),
    paymentDate: MOCK_DATES.futureDate(daysFromNow),
    paymentStatus: 3,
    totalDraftAmount: amount,
    monthlyPaymentAmount: amount,
    paymentDue: [
      {
        dueDate: MOCK_DATES.paymentDueDate().toISOString(),
        totalMonthlyPayment: amount,
        principalAndInterest: MOCK_BALANCES.mortgage.principalAndInterest,
        taxAndInsurance: MOCK_BALANCES.mortgage.taxAndInsurance,
        isSuspense: false,
      },
    ],
    fees: [],
    additionalPrincipal: opts.additionalPrincipal ?? 0,
    additionalEscrow: opts.additionalEscrow ?? 0,
    paymentProfileId: opts.profileId ?? MOCK_BANK_ACCOUNTS.chase.profileId,
    paymentProfileDetails: {
      firstName: 'John',
      lastName: 'Smith',
      accountType: 0,
      routingNumber: MOCK_BANK_ACCOUNTS.chase.routingNumber,
      accountNumber: '****4567',
      bankName: MOCK_BANK_ACCOUNTS.chase.bankName,
    },
    paymentFrequency: 0,
    channelId: opts.channelId ?? 2,
    paymentCancellationCutoffDate: MOCK_DATES.futureDate(daysFromNow),
  };
}

function buildPendingAutopay(id: string, daysFromNow: number, amount: number) {
  return {
    paymentId: id,
    loanNumber: 1234567890,
    confirmationNumber: '',
    createdAt: MOCK_DATES.paymentDate(30),
    paymentDate: MOCK_DATES.futureDate(daysFromNow),
    paymentStatus: 3,
    totalDraftAmount: amount,
    monthlyPaymentAmount: amount,
    paymentDue: [
      {
        dueDate: MOCK_DATES.paymentDueDate().toISOString(),
        totalMonthlyPayment: amount,
        principalAndInterest: MOCK_BALANCES.mortgage.principalAndInterest,
        taxAndInsurance: MOCK_BALANCES.mortgage.taxAndInsurance,
        isSuspense: false,
      },
    ],
    fees: [],
    additionalPrincipal: 0,
    additionalEscrow: 0,
    paymentProfileId: MOCK_BANK_ACCOUNTS.chase.profileId,
    paymentProfileDetails: {
      firstName: 'John',
      lastName: 'Smith',
      accountType: 0,
      routingNumber: MOCK_BANK_ACCOUNTS.chase.routingNumber,
      accountNumber: '****4567',
      bankName: MOCK_BANK_ACCOUNTS.chase.bankName,
    },
    paymentFrequency: 1,
    channelId: 2,
    paymentCancellationCutoffDate: MOCK_DATES.futureDate(daysFromNow),
  };
}

export const paymentHistoryMock = {
  'with-history': {
    pending: [
      buildPendingOtp('otp-1', 5, MOCK_BALANCES.mortgage.paymentDue, {
        confirmationNumber: 'CONF-OTP-001',
      }),
      buildPendingOtp('otp-2', 12, MOCK_BALANCES.mortgage.paymentDue, {
        confirmationNumber: 'CONF-OTP-002',
        profileId: MOCK_BANK_ACCOUNTS.bankOfAmerica.profileId,
        additionalPrincipal: 200,
      }),
      buildPendingAutopay('autopay-1', 3, MOCK_BALANCES.mortgage.paymentDue),
    ],
    posted: [
      {
        id: 'posted-1',
        transactionGroup: 'payment_transaction',
        paymentDate: MOCK_DATES.paymentDate(30),
        paymentDueDate: MOCK_DATES.paymentDate(30),
        paymentDescription: 'Autopay',
        paymentAmount: MOCK_BALANCES.mortgage.paymentDue,
        principalAmount: 1500,
        interestAmount: 635.49,
        escrow: 711.83,
        fees: 0,
        unappliedFunds: 0,
        fhaPaymentSupplement: 0,
        buydown: 0,
        njFireFeeAmount: 0,
      },
      {
        id: 'posted-2',
        transactionGroup: 'payment_transaction',
        paymentDate: MOCK_DATES.paymentDate(60),
        paymentDueDate: MOCK_DATES.paymentDate(60),
        paymentDescription: 'One-Time Payment',
        paymentAmount: MOCK_BALANCES.mortgage.paymentDue,
        principalAmount: 1510,
        interestAmount: 625.49,
        escrow: 711.83,
        fees: 0,
        unappliedFunds: 0,
        fhaPaymentSupplement: 0,
        buydown: 0,
        njFireFeeAmount: 0,
      },
      {
        id: 'posted-3',
        transactionGroup: 'payment_transaction',
        paymentDate: MOCK_DATES.paymentDate(90),
        paymentDueDate: MOCK_DATES.paymentDate(90),
        paymentDescription: 'Autopay',
        paymentAmount: MOCK_BALANCES.mortgage.paymentDue,
        principalAmount: 1520,
        interestAmount: 615.49,
        escrow: 711.83,
        fees: 0,
        unappliedFunds: 0,
        fhaPaymentSupplement: 0,
        buydown: 0,
        njFireFeeAmount: 0,
      },
    ],
  },

  'max-pending-otp': {
    pending: [
      buildPendingOtp('otp-1', 3, MOCK_BALANCES.mortgage.paymentDue, {
        confirmationNumber: 'CONF-OTP-001',
      }),
      buildPendingOtp('otp-2', 7, MOCK_BALANCES.mortgage.paymentDue, {
        confirmationNumber: 'CONF-OTP-002',
        additionalPrincipal: 200,
      }),
      buildPendingOtp('otp-3', 14, MOCK_BALANCES.mortgage.paymentDue, {
        confirmationNumber: 'CONF-OTP-003',
        additionalEscrow: 100,
      }),
    ],
    posted: [
      {
        id: 'posted-1',
        transactionGroup: 'payment_transaction',
        paymentDate: MOCK_DATES.paymentDate(30),
        paymentDueDate: MOCK_DATES.paymentDate(30),
        paymentDescription: 'Autopay',
        paymentAmount: MOCK_BALANCES.mortgage.paymentDue,
        principalAmount: 1500,
        interestAmount: 635.49,
        escrow: 711.83,
        fees: 0,
        unappliedFunds: 0,
        fhaPaymentSupplement: 0,
        buydown: 0,
        njFireFeeAmount: 0,
      },
    ],
  },

  'no-history': {
    pending: [],
    posted: [],
  },

  'pending-only': {
    pending: [
      buildPendingAutopay('autopay-1', 5, MOCK_BALANCES.mortgage.paymentDue),
      buildPendingAutopay('autopay-2', 35, MOCK_BALANCES.mortgage.paymentDue),
    ],
    posted: [],
  },

  'with-failed': {
    pending: [],
    posted: [
      {
        id: 'posted-1',
        transactionGroup: 'payment_transaction',
        paymentDate: MOCK_DATES.paymentDate(5),
        paymentDueDate: MOCK_DATES.paymentDate(5),
        paymentDescription: 'One-Time Payment',
        paymentAmount: MOCK_BALANCES.mortgage.paymentDue,
        principalAmount: 0,
        interestAmount: 0,
        escrow: 0,
        fees: 0,
        unappliedFunds: 0,
        fhaPaymentSupplement: 0,
        buydown: 0,
        njFireFeeAmount: 0,
      },
      {
        id: 'posted-2',
        transactionGroup: 'payment_transaction',
        paymentDate: MOCK_DATES.paymentDate(30),
        paymentDueDate: MOCK_DATES.paymentDate(30),
        paymentDescription: 'Autopay',
        paymentAmount: MOCK_BALANCES.mortgage.paymentDue,
        principalAmount: 1500,
        interestAmount: 635.49,
        escrow: 711.83,
        fees: 0,
        unappliedFunds: 0,
        fhaPaymentSupplement: 0,
        buydown: 0,
        njFireFeeAmount: 0,
      },
      {
        id: 'posted-3',
        transactionGroup: 'payment_transaction',
        paymentDate: MOCK_DATES.paymentDate(60),
        paymentDueDate: MOCK_DATES.paymentDate(60),
        paymentDescription: 'Autopay',
        paymentAmount: MOCK_BALANCES.mortgage.paymentDue,
        principalAmount: 1510,
        interestAmount: 625.49,
        escrow: 711.83,
        fees: 0,
        unappliedFunds: 0,
        fhaPaymentSupplement: 0,
        buydown: 0,
        njFireFeeAmount: 0,
      },
    ],
  },

  'heloc-history': {
    pending: [],
    posted: [
      {
        id: 'posted-1',
        transactionGroup: 'payment_transaction',
        paymentDate: MOCK_DATES.paymentDate(30),
        paymentDueDate: MOCK_DATES.paymentDate(30),
        paymentDescription: 'Minimum Payment',
        paymentAmount: MOCK_BALANCES.heloc.minPayment,
        principalAmount: 100,
        interestAmount: 50,
        escrow: 0,
        fees: 0,
        unappliedFunds: 0,
        fhaPaymentSupplement: 0,
        buydown: 0,
        njFireFeeAmount: 0,
      },
      {
        id: 'draw-1',
        transactionGroup: 'payment_transaction',
        paymentDate: MOCK_DATES.paymentDate(45),
        paymentDueDate: MOCK_DATES.paymentDate(45),
        paymentDescription: 'Draw',
        paymentAmount: 5000.0,
        principalAmount: 5000,
        interestAmount: 0,
        escrow: 0,
        fees: 0,
        unappliedFunds: 0,
        fhaPaymentSupplement: 0,
        buydown: 0,
        njFireFeeAmount: 0,
      },
      {
        id: 'posted-2',
        transactionGroup: 'payment_transaction',
        paymentDate: MOCK_DATES.paymentDate(60),
        paymentDueDate: MOCK_DATES.paymentDate(60),
        paymentDescription: 'Minimum Payment',
        paymentAmount: MOCK_BALANCES.heloc.minPayment,
        principalAmount: 100,
        interestAmount: 50,
        escrow: 0,
        fees: 0,
        unappliedFunds: 0,
        fhaPaymentSupplement: 0,
        buydown: 0,
        njFireFeeAmount: 0,
      },
    ],
  },
};

export const submitPaymentMock = {
  success: {
    isSuccess: true,
    confirmationNumber: `CONF-${Date.now()}`,
    message: 'Payment submitted successfully',
    scheduledDate: MOCK_DATES.futureDate(1),
  },
  'insufficient-funds': {
    isSuccess: false,
    confirmationNumber: '',
    message: 'Payment failed due to insufficient funds',
  },
  'invalid-account': {
    isSuccess: false,
    confirmationNumber: '',
    message: 'Bank account validation failed',
  },
  error: {
    isSuccess: false,
    confirmationNumber: '',
    message: 'An error occurred while processing your payment. Please try again.',
  },
};

export const validateRoutingNumberMock = {
  valid: {
    valid: 1,
    routingNumber: '122199983',
    bankName: 'Loan Depot Test',
  },
  invalid: {
    valid: 0,
    routingNumber: '',
    bankName: '',
    error: 'Invalid routing number',
  },
};
